<script lang="ts" setup>
import { computed } from 'vue'

import { BlockContainer } from '@toni/brand-ui'
import { usePageStore } from '@toni/rendering/src/stores/page'

import { usePageBlockWidth } from '../../../composables/use-page-block-width'
import { useContentBlock } from '../../../content-blocks/composables/use-content-block'
import MediaGallery from './MediaGallery.vue'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'slider')

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)

const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
</script>

<template>
  <BlockContainer :size="size"
                  class="my-6">
    <MediaGallery :gallery-items="contentBlock.data.slider?.galleryItems ?? []" />
  </BlockContainer>
</template>
